import React, { useState } from 'react'
import { Link,useLocation } from "react-router-dom"
import { toTitleCase } from '../../services/helpers/helpers';
import { headerAssets} from '../../assets/media'
import StyledButton from '../../components/layout_components/StyledButton'
import { BiPlay } from "react-icons/bi"
import ModalVideo from 'react-modal-video'
import '../../../node_modules/react-modal-video/scss/modal-video.scss';
import MobileMenu from '../../components/layout_components/MobileMenu';
import DesktopNav from '../../components/layout_components/DesktopNav';

const { mainArt } = headerAssets

const Header = () => {

    const location = useLocation()


    const headerContent = {

        hero: {
            heroText: "Assess & hire talent remotely with games!",
            heroDesc: "Use online gamified assessment technology to improve your candidate experience, enhance employer brand and make better hiring decisions with advanced data-points.",
        }
    }

    const [isOpen, setisOpen] = useState(false)


    const openModalVideo = () => {
        setisOpen(true)
    }
    return (
        <>
            <header className={`${['/', '/test-library'].includes(location.pathname) && 'bg-[#FFD700]'} py-4`}>
                {/* modal video */}
                <ModalVideo channel='youtube' autoplay isOpen={isOpen} videoId="lO4pu2T6iSg" onClose={() => setisOpen(false)} />

                {/* Mobile Navbar */}
                <MobileMenu />
                {/* Desktop Navbar */}
                <DesktopNav />



                {/* for home */}
                {location.pathname === '/' &&
                    <div className="hero flex flex-col 2xl:justify-between items-center xl:items-start sm:flex sm:flex-row  mt-5 sm:mt-10 w-full sm:w-[38rem] lg:w-[90vw] mx-auto">
                        {/* left */}
                        <div className="left w-[22rem] p-2 sm:w-[22rem] lg:w-[500px] xl:w-[790px] 2xl:w-[896px]">
                            <div className="mainText sm:mt-6 xl:pr-[100px]">
                                <h1 className='text-[24px]  text-[#333333] font-[700] text-center leading-[40px] sm:text-left 2xl:text-left 2xl:text-[3.5rem] 2xl:leading-[60px] lg:text-[2.5rem] lg:leading-[40px] xl:leading-[45px]'>
                                    {toTitleCase(headerContent.hero.heroText)}
                                </h1>
                                <p className='  text-center text-[#333333] text-[16px] leading-[24px] font-[500] p-2 sm:w-[20rem] sm:text-left lg:w-[500px] lg:text-left 2xl:text-[24px] 2xl:leading-[39px]  2xl:w-[667px] mx-auto lg:mx-0 lg:leading-[30px] lg:mt-4 sm:text-sm sm:p-0 2xl:mt-5'>
                                    {headerContent.hero.heroDesc}
                                </p>
                                {/* buttons */}
                                <div className="buttons sm:justify-start flex lg:justify-between justify-center py-2 lg:w-[26rem] mt-5 lg:mt-2 2xl:mt-[40px] 2xl:w-[33rem] sm:mb-10">
                                    <div className="left mr-2 lg:mr-0">
                                        <Link to={"/free"}>

                                            <StyledButton btnText={"START FREE TRIAL"} customStyle="!py-[0.38rem] !w-[130px]  lg:!w-[200px] h-[40px] text-[12px] !font-semibold 2xl:!w-[280px]" />
                                        </Link>
                                    </div>
                                    <div className="right ml-2">
                                        <StyledButton btnEventHandler={openModalVideo} btnText={"HOW IT WORKS"} customStyle={`!bg-transparent !text-[#333333] border-2 border-[#333333] !hover:bg-[#333333] !hover:text-white lg:!w-[250px] 2xl:!w-[300px] h-[40px] text-[12px] !font-semibold`}>
                                            <BiPlay className=' -mt-[2px] sm:mt-[2px] ml-2 sm:ml-5 xl:ml-1 lg:ml-1 xl:!mt-[-2px] 2xl:!-mt-[2px] lg:-mt-[2px]' />
                                        </StyledButton>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="right">
                            <img src={mainArt} className="w-[285px] h-[300px] mx-auto hidden sm:block md:h-[242px] lg:w-[700px] lg:h-[350px] 2xl:w-[800px] 2xl:h-[590px] lg:object-contain " alt="" />
                        </div>

                    </div>
                }
                {/* for home end */}

            </header>

            {location.pathname === '/' &&
                <svg viewBox="0 0 500 150" preserveAspectRatio="none" style={{ height: '6rem', width: '100%' }}><path d="M-3.76,53.79 C217.45,1.50 304.92,204.77 500.00,49.99 L500.00,0.00 L0.00,0.00 Z" style={{ stroke: 'none', fill: '#FFD700' }} /></svg>
            }
        </>
    )
}

export default Header